// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Projekt-Upload (Datenimport) */
.pu-modal .ant-modal-body {
  max-height: 78vh;
  overflow-y: auto;
}

.pu-preflight {
  margin-bottom: 12px;
}

.pu-intro {
  margin-bottom: 12px;
}

.pu-alert {
  margin-top: 10px;
}

.pu-dragger {
  margin-bottom: 12px;
}

.pu-selection {
  margin-top: 8px;
}

.pu-group-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 8px 0;
  flex-wrap: wrap;
}

.pu-select {
  min-width: 320px;
}

.pu-preview {
  margin-top: 8px;
}

.pu-inline-tag {
  margin-left: 8px;
}

.pu-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
  flex-wrap: wrap;
}

.pu-info-icon {
  margin-left: 6px;
  color: #8f968a;
}

.pu-job {
  margin-top: 16px;
}

.pu-meta {
  display: block;
  margin: 8px 0;
  font-size: 12px;
}

.pu-collapse {
  margin-top: 8px;
}

.pu-project-header {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.pu-folder {
  font-size: 12px;
}

.pu-project .ant-alert {
  margin-bottom: 10px;
}

.pu-section {
  margin-top: 10px;
}

.pu-list {
  margin: 6px 0 0 0;
  padding-left: 18px;
}

.pu-list li {
  margin-bottom: 4px;
}

.pu-hint {
  display: block;
  font-size: 12px;
}

.pu-detail {
  display: inline-block;
  margin-top: 2px;
  font-size: 12px;
  text-decoration: underline dotted;
  cursor: help;
}

.pu-warn-icon {
  color: #d48806;
}

.pu-status-tag {
  margin-right: 0;
}

.pu-history {
  margin-top: 20px;
  border-top: 1px solid #e6e9dc;
  padding-top: 12px;
}

.pu-history-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.pu-history-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.pu-history-item {
  width: 100%;
  display: grid;
  grid-template-columns: 120px 150px 110px 1fr;
  gap: 8px;
  align-items: center;
  text-align: left;
  background: none;
  border: none;
  padding: 6px 8px;
  border-radius: 6px;
  cursor: pointer;
  font: inherit;
  color: inherit;
}

.pu-history-item:hover,
.pu-history-active .pu-history-item {
  background: #f3f7e2;
}

.pu-history-date,
.pu-history-user {
  font-size: 12px;
  color: #5d6457;
}

.pu-history-summary {
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Ablage-Schema: what is accepted, what is not */
.pu-schema {
  margin: 4px 0 14px;
  border: 1px solid #e6e9dc;
  border-radius: 10px;
  background: #fbfcf7;
  padding: 12px 14px;
}

.pu-schema-title {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #5d6457;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
}

.pu-ok {
  color: #5f7d16;
}

.pu-bad {
  color: #cf1322;
}

.pu-tree {
  margin: 0 0 12px;
  padding: 10px 12px;
  background: #ffffff;
  border: 1px solid #e6e9dc;
  border-radius: 8px;
  font-size: 11.5px;
  line-height: 1.5;
  overflow-x: auto;
  color: #1c211a;
}

.pu-schema-cols {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

@media (max-width: 760px) {
  .pu-schema-cols {
    grid-template-columns: 1fr;
  }
}

.pu-schema-col {
  padding: 10px 12px;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid #e6e9dc;
}

.pu-schema-ok {
  border-left: 3px solid #b6ce3b;
}

.pu-schema-bad {
  border-left: 3px solid #e4694f;
}

.pu-schema-list {
  margin: 0;
  padding-left: 18px;
  font-size: 12.5px;
  line-height: 1.45;
}

.pu-schema-list li {
  margin-bottom: 6px;
}

.pu-schema-list .ant-typography {
  font-size: 11.5px;
}

.pu-schema-note {
  margin-top: 8px;
  font-size: 11.5px;
  color: #5d6457;
}

.pu-slow {
  margin: 0 0 12px;
}

.pu-slow .ant-alert-message {
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/components/Ingest/ProjectUpload.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,4CAA4C;EAC5C,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* Projekt-Upload (Datenimport) */\n.pu-modal .ant-modal-body {\n  max-height: 78vh;\n  overflow-y: auto;\n}\n\n.pu-preflight {\n  margin-bottom: 12px;\n}\n\n.pu-intro {\n  margin-bottom: 12px;\n}\n\n.pu-alert {\n  margin-top: 10px;\n}\n\n.pu-dragger {\n  margin-bottom: 12px;\n}\n\n.pu-selection {\n  margin-top: 8px;\n}\n\n.pu-group-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 8px 0;\n  flex-wrap: wrap;\n}\n\n.pu-select {\n  min-width: 320px;\n}\n\n.pu-preview {\n  margin-top: 8px;\n}\n\n.pu-inline-tag {\n  margin-left: 8px;\n}\n\n.pu-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  margin-top: 12px;\n  flex-wrap: wrap;\n}\n\n.pu-info-icon {\n  margin-left: 6px;\n  color: #8f968a;\n}\n\n.pu-job {\n  margin-top: 16px;\n}\n\n.pu-meta {\n  display: block;\n  margin: 8px 0;\n  font-size: 12px;\n}\n\n.pu-collapse {\n  margin-top: 8px;\n}\n\n.pu-project-header {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.pu-folder {\n  font-size: 12px;\n}\n\n.pu-project .ant-alert {\n  margin-bottom: 10px;\n}\n\n.pu-section {\n  margin-top: 10px;\n}\n\n.pu-list {\n  margin: 6px 0 0 0;\n  padding-left: 18px;\n}\n\n.pu-list li {\n  margin-bottom: 4px;\n}\n\n.pu-hint {\n  display: block;\n  font-size: 12px;\n}\n\n.pu-detail {\n  display: inline-block;\n  margin-top: 2px;\n  font-size: 12px;\n  text-decoration: underline dotted;\n  cursor: help;\n}\n\n.pu-warn-icon {\n  color: #d48806;\n}\n\n.pu-status-tag {\n  margin-right: 0;\n}\n\n.pu-history {\n  margin-top: 20px;\n  border-top: 1px solid #e6e9dc;\n  padding-top: 12px;\n}\n\n.pu-history-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.pu-history-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.pu-history-item {\n  width: 100%;\n  display: grid;\n  grid-template-columns: 120px 150px 110px 1fr;\n  gap: 8px;\n  align-items: center;\n  text-align: left;\n  background: none;\n  border: none;\n  padding: 6px 8px;\n  border-radius: 6px;\n  cursor: pointer;\n  font: inherit;\n  color: inherit;\n}\n\n.pu-history-item:hover,\n.pu-history-active .pu-history-item {\n  background: #f3f7e2;\n}\n\n.pu-history-date,\n.pu-history-user {\n  font-size: 12px;\n  color: #5d6457;\n}\n\n.pu-history-summary {\n  font-size: 13px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Ablage-Schema: what is accepted, what is not */\n.pu-schema {\n  margin: 4px 0 14px;\n  border: 1px solid #e6e9dc;\n  border-radius: 10px;\n  background: #fbfcf7;\n  padding: 12px 14px;\n}\n\n.pu-schema-title {\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #5d6457;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 6px;\n}\n\n.pu-ok {\n  color: #5f7d16;\n}\n\n.pu-bad {\n  color: #cf1322;\n}\n\n.pu-tree {\n  margin: 0 0 12px;\n  padding: 10px 12px;\n  background: #ffffff;\n  border: 1px solid #e6e9dc;\n  border-radius: 8px;\n  font-size: 11.5px;\n  line-height: 1.5;\n  overflow-x: auto;\n  color: #1c211a;\n}\n\n.pu-schema-cols {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n@media (max-width: 760px) {\n  .pu-schema-cols {\n    grid-template-columns: 1fr;\n  }\n}\n\n.pu-schema-col {\n  padding: 10px 12px;\n  border-radius: 8px;\n  background: #ffffff;\n  border: 1px solid #e6e9dc;\n}\n\n.pu-schema-ok {\n  border-left: 3px solid #b6ce3b;\n}\n\n.pu-schema-bad {\n  border-left: 3px solid #e4694f;\n}\n\n.pu-schema-list {\n  margin: 0;\n  padding-left: 18px;\n  font-size: 12.5px;\n  line-height: 1.45;\n}\n\n.pu-schema-list li {\n  margin-bottom: 6px;\n}\n\n.pu-schema-list .ant-typography {\n  font-size: 11.5px;\n}\n\n.pu-schema-note {\n  margin-top: 8px;\n  font-size: 11.5px;\n  color: #5d6457;\n}\n\n.pu-slow {\n  margin: 0 0 12px;\n}\n\n.pu-slow .ant-alert-message {\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
